export function MutationObserver(...args) {
  return window?.MutationObserver ? new window.MutationObserver(...args)
    : { observe() {}, unobserve() {}, disconnect() {} };
}
